export * from './app-sidebar-footer.component';



// WEBPACK FOOTER //
// ./src/app/shared/app-sidebar-footer/index.ts